const en = {
  home: {
    helloworld: 'Hello, 🌎!',
    reachout: 'Reach out!',
  },
  footer: {
    copyright: '© 2025 Adriano Vieira. All rights reserved.',
  },
}

export default en
